<style lang="scss" scoped="">
.el-row {
  margin-bottom: 10px;
}

.org-info {
  background: #fff;
  margin-bottom: 20px;
}

.base-pic-list {
  display: flex;
  flex-wrap: wrap;

  .base-pic-item {
    border: 1px solid #eee;
    position: relative;
    cursor: pointer;
    width: 180px;
    margin: 5px;
    padding: 10px;
    font-size: 12px;

    img {
      width: 180px;
      height: 180px;
      display: block;
      background: #ccc;

    }

  }
}

.batch-upload-form {
  padding-top: 20px;
  padding-right: 80px
}

</style>
<template>
  <div class="org-info">
    <form-show-part :pageSetsItem="pageSets[0]" :currentTab="{}">
      <template slot="content">
        <el-form ref="form" :rules="rules" :model="form" style="margin-top: -20px"
                 label-width="100px" class="batch-upload-form">
          <el-form-item>
            <oms-upload-relation uploadUrl="/qingstor/code/pre" deleteUrl="/code-upload/file"
                                 :fileList="fileList" :formData="{objectType:'traceCodeByOrg',
                                   type: '2'}" uploadTip="请批量选择关联关系XML文件"
                                 accept="xml"
                                 @change="changeFiles" @isProgress="onUploadProgress"
                                 :clearUploadFiles="clearUploadFiles"
                                 @refreshCodes="setIsUploading"></oms-upload-relation>
            <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>
          </el-form-item>
          <perm label="create-product-in-warehouse-order">
            <el-form-item label="成品入库">
              <el-checkbox v-model="orderFlag">系统生成成品入库订单</el-checkbox>
            </el-form-item>
          </perm>
          <el-form-item label="">
            <div style="padding-top: 10px">
              <el-button type="primary" @click="onSubmit" :disabled="doing" :loading="loadingData"
                         v-show="form.fileIdList.length>0&&!uploading">提交
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </template>
    </form-show-part>
    <form-show-part :pageSetsItem="pageSets[1]" :currentTab="{}">
      <template slot="content">
        <div style="padding: 20px;margin-top: -20px" v-show="errorList.length>0">
          <h4><i class="el-icon-error" style="color: red"></i> 失败上传记录</h4>
          <el-table :data="errorList" :header-row-class-name="'headerClass'" ref="orderDetail">
            <el-table-column label="序号" min-width="20" prop="index">
            </el-table-column>
            <el-table-column label="文件名称" min-width="150" prop="name">
            </el-table-column>
            <el-table-column label="失败原因" min-width="150" prop="message">
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px;margin-top: -20px" v-show="successList.length>0">
          <h4><i class="el-icon-success" style="color: limegreen"></i> 成功上传记录</h4>
          <el-table :data="successList" :header-row-class-name="'headerClass'" ref="orderDetail">
            <el-table-column label="序号" min-width="20" prop="index">
            </el-table-column>
            <el-table-column label="文件名称" min-width="150" prop="name">
            </el-table-column>
          </el-table>
        </div>
      </template>
    </form-show-part>
  </div>
</template>
<script>
import {http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';

export default {
  components: {},
  mixins: [methodsMixin],
  data: function () {
    return {
      fileList: [],
      form: {
        fileIdList: []
      },
      doing: false,
      isUploading: false,
      isChecked: false,
      uploadingFiles: [],
      loadingData: false,
      orderFlag: false,
      rules: {},
      successList: [],
      errorList: [],
      attachmentFile: []
    };
  },
  computed: {
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    },
    pageSets() {
      let ary = [
        {name: '源文件批量上传', key: 0}
      ];
      if (this.errorList.length > 0 || this.successList.length > 0) {
        ary.push({name: '历史上传记录', key: 1});
      }
      return ary;
    }
  },
  mounted() {
    this.resetForm();
    this.successList = [];
    this.errorList = [];
    this.attachmentFile = [];
  },
  watch: {},
  methods: {
    resetForm() {
      this.form = {
        fileIdList: []
      };
      this.orderFlag=false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = [];
      this.loadingData = false;
      this.isChecked = false;
    },
    setIsUploading(file) {
      if (!file) return;
      let newFile = Object.assign({}, file, {message: file.response.message});
      if (file.response.state === 'FAIL') {
        this.errorList.push(Object.assign({}, newFile, {index: this.errorList.length + 1}));
      }
      this.attachmentFile.push(file);
      this.uploadingFiles.forEach(val => {
        if (file.uid === val.uid) {
          val.isUploading = false;
        }
      })
    },
    onUploadProgress(file) {
      let containFlag = this.uploadingFiles.some(value => value.uid === file.uid);
      if (!containFlag) {
        let newFile = Object.assign({}, file, {isUploading: true});
        this.uploadingFiles.push(newFile);
      }
    },
    changeFiles(files) {
      this.form.fileIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = [];
    },
    setErrorList(list) {
      if (!list || list.size === 0) {
        return;
      }
      let errorList = list.filter(v => !v.successFlag);
      let successList = list.filter(v => v.successFlag);
      if (successList.length !== 0) {
        successList.forEach(i => {
          let item = this.attachmentFile.find(f => f.attachmentId === i.fileId);
          if (item) {
            i = Object.assign({}, {name: item.name, message: i.message, index: this.successList.length + 1});
            this.successList.push(i);
          }
        })
      }
      if (errorList.length === 0) {
        this.$notify.success({
          message: '批量上传关联关系XML文件成功。'
        });
        let url = '/retrospect/goods/import/id';
        this.$router.push(url);
      } else {
        errorList.forEach(i => {
          let item = this.attachmentFile.find(f => f.attachmentId === i.fileId);
          if (item) {
            i = Object.assign({}, {name: item.name, message: i.message, index: this.errorList.length + 1});
            this.errorList.push(i);
          }
        })
        this.$notify.error({
          duration: 4500,
          message: '解析上传关联关系XML文件失败。'
        });
      }
      this.resetForm();
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        if (!this.form.fileIdList.length) {
          this.$notify.info({
            message: '请选择追溯码文件'
          });
          return;
        }
        this.form.orderFlag = this.orderFlag;
        this.doing = true;
        this.loadingData = true;
        http.post('/code/org/parse/trace-code/file-list', this.form).then(res => {
          this.doing = false;
          this.loadingData = false;
          this.setErrorList(res.data.list);
        }).catch(e => {
          // const h = this.$createElement;
          // this.$notify.error({
          //   duration: 4500,
          //   message: h('i', { style: 'word-break: break-all'}, e.response && e.response.data && e.response.data.msg || '解析失败')
          // });
          this.doing = false;
          this.loadingData = false;
          this.setErrorList(e.response.data.list);
        });
      });
    }
  }
};
</script>
